import axios from 'axios';
import store from './../stores/index';
import router from './../router';

axios.interceptors.request.use(
  function(config) {
    store.commit("startLoad");

    return config;
  },
  function(error) {
    store.commit("stopLoad");

    return Promise.reject(error);
  }
);

axios.interceptors.response.use(
  function(response) {
    store.commit("stopLoad");

    return response;
  },
  function(error) {
    store.commit("stopLoad");

    return Promise.reject(error);
  }
);

axios.interceptors.response.use(
  response => {
    return response;
  },
  error => {
    if (error.response && error.response.status == 401) {
      store.dispatch('auth/logout');
      router.push('/login');
    }

    return Promise.reject(error);
  }
);

axios.defaults.headers.common["Authorization"] = `Bearer ${localStorage.getItem('auth_token')}`;
axios.defaults.baseURL = 'http://konnect2.stonesoupdev.com:5000';

export default axios;
